import axios from 'axios';

// 配置axios
axios.interceptors.request.use(
  config => {
    // Add debug logging for all requests
    console.log('Axios Request:', {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      headers: config.headers
    });
    
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  error => {
    console.error('Axios Request Error:', error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器，处理未授权响应
axios.interceptors.response.use(
  response => {
    console.log('Axios Response:', {
      status: response.status,
      statusText: response.statusText,
      data: response.data,
      headers: response.headers
    });
    return response;
  },
  error => {
    console.error('Axios Response Error:', error);
    console.error('Response Error Details:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      url: error.config?.url,
      method: error.config?.method
    });
    
    if (error.response && error.response.status === 401) {
      // 触发登录模态窗口的显示
      window.dispatchEvent(new CustomEvent('show-login-modal'));
    }
    return Promise.reject(error);
  }
);

// 从环境变量中获取API基础URL，如果不存在则使用默认值
const API_URL = process.env.VUE_APP_API_BASE_URL || 'https://ddrl.xyz/api';

class AIService {
  // 获取随机题目
  getRandomProblem() {
    console.log('Fetching random problem from:', `${API_URL}/ai/api/random-problem`);
    return axios.get(`${API_URL}/ai/api/random-problem`);
  }
  
  // 上传音频或文本
  uploadAudio(formData, model = 'deepseek-r1') {
    // 确保model参数被添加到formData中
    if (model && !formData.has('model')) {
      formData.append('model', model);
    }
    // 注意：Nginx配置了location /api/ 前缀，所以这里应该避免重复
    return axios.post(`${API_URL}/ai/api/upload_audio`, formData);
  }
  
  // 获取文本状态
  getTextStatus(path) {
    console.log('Checking text status at:', `${API_URL}/ai/api/get_text_status?path=${path}`);
    return axios.get(`${API_URL}/ai/api/get_text_status?path=${path}`);
  }
  
  // 获取分析文件
  getAnalysisFile(path, forceRefresh = false) {
    // 添加时间戳参数，确保每次请求都绕过缓存
    const cacheParam = forceRefresh ? `&_nocache=${Date.now()}` : '';
    console.log('Getting analysis file from:', `${API_URL}/ai/api/get_analysis_file?path=${path}${cacheParam}`);
    return axios.get(`${API_URL}/ai/api/get_analysis_file?path=${path}${cacheParam}`);
  }
  
  // 发送追问
  sendFollowUp(message, model = 'deepseek-v3') {
    return axios.post(`${API_URL}/ai/api/send_follow_up`, { message, model });
  }
}

export default new AIService();
